import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiUrlInterceptor } from './shared/services/interceptors/api-url.interceptor';
import { CoreModule } from './core/core.module';
import { TranslateModule, TranslateParser, MissingTranslationHandler } from '@ngx-translate/core';
import { CustomTranslateParser } from './core/i18n/custom-translate-parser';
import { CustomMissingTranslationHandler } from './core/i18n/custom-missing-translation-handler';
import { I18nService } from './core/i18n/i18n.service';
import { LowerCaseUrlSerializer } from './core/lower-case-url-serializer/lower-case-url-serializer';
import { UrlSerializer } from '@angular/router';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    CoreModule,
    TranslateModule.forRoot({
      parser: { provide: TranslateParser, useClass: CustomTranslateParser },
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: CustomMissingTranslationHandler },
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiUrlInterceptor,
      multi: true
    },
    I18nService,
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }